import MobileStepper from '@material-ui/core/MobileStepper';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { useCallback, useLayoutEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Layout from '../Layout';
import {
  Slide1,
  Slide2,
  Slide3,
  Slide4,
  Slide5,
  Slide6,
  Slide7,
  Slide8,
  toWelcome4Path,
} from './Slides';
import SubmitWhenUnload from './SubmitWhenUnload';

const useStyles = makeStyles((theme) => ({
  supportLink: {
    '& > svg': {
      verticalAlign: 'middle',
    },
    '& span': {
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
  },
  stepIndicator: {
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
}));

const slides = [
  Slide1,
  Slide2,
  Slide3,
  Slide4,
  Slide5,
  Slide6,
  Slide7,
  Slide8,
];

function welcomePagePath(page: string) {
  return toWelcome4Path({ page });
}

export default function Main() {
  const classes = useStyles();
  const { page } = useParams<{ page: string }>();
  const currentPage = Number(page);
  const history = useHistory();
  const activeStep = currentPage - 1;
  useLayoutEffect(
    () => {
      if (!currentPage) history.replace(welcomePagePath('1'));
    },
    [history, currentPage],
  );
  const handleSlideFinish = useCallback(() => {
    if (currentPage === slides.length) {
      return;
    }
    history.push(welcomePagePath(String(currentPage + 1)));
  }, [currentPage, history]);
  const handleGoBack = useCallback(() => {
    if (currentPage === 1) {
      return;
    }
    history.push(welcomePagePath(String(currentPage - 1)));
  }, [currentPage, history]);
  const slideComponents = slides.map((Slide, index) => (index === currentPage - 1
    ? <Slide key={Slide.name} onNext={handleSlideFinish} /> : null));
  return (
    <Layout>
      <MobileStepper
        variant="dots"
        steps={slides.length}
        position="static"
        activeStep={activeStep}
        className={classes.stepIndicator}
        nextButton={null}
        backButton={(
          <IconButton size="small" aria-label="Back" onClick={handleGoBack} disabled={activeStep === 0}>
            <ArrowBackIcon />
          </IconButton>
        )}
      />
      <SubmitWhenUnload />
      {slideComponents}
    </Layout>
  );
}
